// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__vTi0L","button_added":"AddButton_button_added__vzhzs","button__icon":"AddButton_button__icon__lhReq"};